import { render, staticRenderFns } from "./charmList.vue?vue&type=template&id=00464c18"
import script from "./charmList.vue?vue&type=script&lang=js"
export * from "./charmList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00464c18')) {
      api.createRecord('00464c18', component.options)
    } else {
      api.reload('00464c18', component.options)
    }
    module.hot.accept("./charmList.vue?vue&type=template&id=00464c18", function () {
      api.rerender('00464c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/charmList.vue"
export default component.exports